import React, { useEffect, useState } from 'react';

import AccountService from '../../../../Service/AccountService';
import Swal from 'sweetalert2';

export default function useFetchRecordTopupDetail(id = null) {
	const [state, setState] = useState({ _isLoading: false, data: [] });

	const setTopupSource = async () => {
		setState({ _isLoading: true });

		try {
			const response = await AccountService.getRecordTopupDetail(id);

			setState({ data: response, _isLoading: false });
		} catch (error) {
			this.setState({ _isLoading: false });
			toastWhenFail(`Error: ${error.message}`);
		}
	};

	const toastWhenFail = resp => {
		Swal.fire({
			allowOutsideClick: false,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			title: 'Something went wrong!',
			text: resp,
			// icon: 'error',
			customClass: 'otp_message_success'
		});
	};

	useEffect(() => {
		setTopupSource();
	}, [id]);
	return { state };
}
